export const focusRingClassName =
  'focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 focus-visible:outline-none';

export const focusRingStaticClassName = 'ring-2 ring-blue-400 ring-offset-2 outline-none';

export function isVisibleInViewport(element: HTMLElement | null | undefined): boolean {
  if (!element) {
    return false;
  }

  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
